import PropTypes from 'prop-types';

function Checkbox({ name, disabled, checked = false, label, onChange }) {
  const htmlText = `<p>${label}</p>`;
  return (
    <div className="input-group for-checkbox">
      <label className="checkbox">
        <input
          name={name}
          type="checkbox"
          disabled={disabled}
          className="gh-input post-settings-featured"
          checked={checked}
          onChange={onChange}
        />
        <span className="input-toggle-component"></span>
        <div dangerouslySetInnerHTML={{ __html: htmlText }}></div>
      </label>
    </div>
  );
}

Checkbox.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
};

export default Checkbox;
